"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _fonts = require("@quixeltools/quixel-ui-library/dist/utils/fonts");

var _ = require("./..");

var _glamor = require("glamor");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _utils = require("../../EpicMigration/utils");

var _eol = require("../../redux/modules/eol");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var accountDropdown = (0, _glamor.css)({
  color: _css.pallets.grayMidLight_dropDowns,
  margin: "-0.8rem 0px"
});

var group = (0, _glamor.css)({
  padding: (0, _css.unitRem)(0.75) + " " + (0, _css.unitRem)(0.75)
});

var borderBottom = (0, _glamor.css)({
  borderBottom: "1px solid " + _css.pallets.darkGray_background,
  ":last-child": {
    borderBottom: "none"
  }
});

var additionalGroup = (0, _glamor.css)({
  paddingTop: "0.5rem",
  paddingBottom: "0.5rem"
});

var highLight = (0, _glamor.css)({
  paddingTop: "0.6rem",
  paddingBottom: "0.6rem",
  "&:hover": {
    opacity: "1",
    background: _css.pallets.lightGray_hightlight,
    "& a": {
      color: "white"
    }
  }
});

var icon = function icon(img) {
  return (0, _glamor.css)((0, _css.bgContain)(img), {
    width: "28px",
    height: "auto"
  });
};

var usernameGroup = (0, _glamor.css)({
  fontWeight: 400,
  padding: "" + (0, _css.unitRem)(0.75),
  overflow: "hidden",
  whiteSpace: "no-wrap",
  wordBreak: "break-all",
  textAlign: "center"
});
var points = (0, _glamor.css)(_fonts.H6, {
  color: _css.pallets.white,
  textTransform: "uppercase"
});
var link = (0, _glamor.css)({
  display: "block",

  width: "100%",
  textAlign: "left",
  lineHeight: "2px",
  marginLeft: "0.6rem",

  padding: (0, _css.unitRem)(0.3) + " " + (0, _css.unitRem)(0.125),
  ":first-child": {
    paddingTop: (0, _css.unitRem)(0.3)
  },

  ":last-child": {
    paddingBottom: (0, _css.unitRem)(0.3)
  },
  "& a": {
    textUnderlinePosition: "under",
    textTransform: "uppercase",
    fontWeight: 600,
    letterSpacing: "0.5px"
  }
});

var pointsGroup = (0, _glamor.css)({
  textAlign: "center",
  display: "flex",
  justifyContent: "space-around",
  flexDirection: "column"
});
var refill = (0, _glamor.css)({
  display: "flex",
  marginTop: (0, _css.unitRem)(0.5),
  flexDirection: "column",
  justifyContent: "space-between",
  "& span button": {
    paddingLeft: "1.85rem",
    paddingRight: "1.85rem"
  }
});

var subscribeButton = (0, _glamor.css)({
  "& span a": {
    width: "100%"
  }
});

var alignItem = (0, _glamor.css)({
  display: "flex",
  justifyContent: "space-between",
  marginBottom: (0, _css.unitRem)(0.7),
  ":last-child": {
    marginBottom: 0
  }
});

var AccountDropdown = function AccountDropdown(props) {
  // Check if user is a studio or custom plan user
  var userHasAnActiveExcludedPlan = function userHasAnActiveExcludedPlan() {
    return props.planId && props.eolConfig && props.eolConfig.common.excludedLicensees.includes(props.planId) && props.isActive;
  };
  var showPoints = props.planId && (0, _utils.shouldShowPoints)(props.planId);
  var addPointsAllowed = props.isActive && props.doesGetCharged === true && (0, _utils.isAddPointsAllowed)(props.planId);
  var showRefillInXDays = props.refillIn > 0 && props.doesGetCharged === true && (0, _utils.shouldShowRefillInXDays)(props.planId);

  return _react2.default.createElement(
    "div",
    accountDropdown,
    !props.isActive && (0, _eol.getIsPricingEnabled)(props.eolConfig) && _react2.default.createElement(
      "div",
      {
        className: (0, _glamor.css)(group, borderBottom, {
          textAlign: "center",
          border: "none",
          paddingBottom: 0
        }) },
      _react2.default.createElement(_Button2.default, {
        small: true,
        mode: "secondary",
        label: "SUBSCRIBE",
        to: props.onSubscribeClick,
        className: subscribeButton
      })
    ),
    _react2.default.createElement(
      "div",
      (0, _extends3.default)({ className: (0, _glamor.css)(group, borderBottom) }, usernameGroup),
      _react2.default.createElement(
        "span",
        {
          className: (0, _glamor.css)(_fonts.p5, {
            color: _css.pallets.gray_text,
            letterSpacing: "0px",
            paddingBottom: (0, _css.unitRem)(0.25)
          }) },
        props.username
      )
    ),
    props.planName,
    showPoints && _react2.default.createElement(
      "div",
      (0, _glamor.css)(group, borderBottom, pointsGroup),
      _react2.default.createElement(
        "span",
        null,
        _react2.default.createElement(
          "span",
          { className: points },
          " ",
          props.points
        ),
        _react2.default.createElement(
          "span",
          { className: points },
          " P"
        )
      ),
      !props.hasMonetizationStopped && (showRefillInXDays || addPointsAllowed) && _react2.default.createElement(
        "span",
        refill,
        showRefillInXDays && _react2.default.createElement(
          "span",
          {
            className: (0, _glamor.css)({
              color: "#808080",
              marginBottom: addPointsAllowed ? (0, _css.unitRem)(1) : 0,
              letterSpacing: -0.4
            }) },
          "Points will refill in: ",
          props.refillIn,
          " days"
        ),
        addPointsAllowed && !props.hasMonetizationStopped && _react2.default.createElement(_Button2.default, {
          small: true,
          className: (0, _glamor.css)({
            "& button": {
              width: "100%",
              letterSpacing: "0.75px",
              fontWeight: "700"
            }
          }),
          mode: "primary",
          label: "ADD MEGASCANS POINTS",
          onClick: props.onAddPointsClick
        })
      )
    ),
    _react2.default.createElement(
      "div",
      { className: (0, _glamor.css)(additionalGroup, borderBottom) },
      _react2.default.createElement(
        "div",
        { className: (0, _glamor.css)(group, highLight) },
        _react2.default.createElement(
          "div",
          { className: alignItem },
          _react2.default.createElement("span", {
            className: icon("https://d3uwib8iif8w1p.cloudfront.net/megascans/icons/account.svg")
          }),
          _react2.default.createElement(_.TextButtonLibrary, {
            className: link,
            mode: "small-normal",
            label: "Account",
            to: props.external ? "" : props.accountTo,
            onClick: props.external ? props.onAccountsClick : undefined
          })
        )
      ),
      !userHasAnActiveExcludedPlan() && (props.canRefund || props.isRefundInProgress) && _react2.default.createElement(
        "div",
        { className: (0, _glamor.css)(group, highLight) },
        _react2.default.createElement(
          "div",
          { className: alignItem },
          _react2.default.createElement("span", { className: icon("icons/convert.svg") }),
          _react2.default.createElement(_.TextButtonLibrary, {
            className: link,
            mode: "small-normal",
            label: props.canRefund ? "Convert your points balance" : "View cash refund progress",
            to: "/convert-points"
          })
        )
      ),
      _react2.default.createElement(
        "div",
        { className: (0, _glamor.css)(group, highLight) },
        _react2.default.createElement(
          "div",
          { className: alignItem },
          _react2.default.createElement("span", {
            className: icon("https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/sign_out.svg")
          }),
          _react2.default.createElement(_.TextButtonLibrary, {
            className: (0, _glamor.css)({ "& a": { textDecoration: "none" } }, link),
            mode: "small-normal",
            label: "Sign Out",
            onClick: props.onSignoutClick,
            to: "/"
          })
        )
      )
    )
  );
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    canRefund: state.user.refundEligibility.data && Boolean(state.user.refundEligibility.data.isEligible),
    isRefundInProgress: state.user.refundEligibility.error && (state.user.refundEligibility.error.code === "REFUND_IN_PROGRESS" || state.user.refundEligibility.error.code === "REFUND_ALREADY_INITIATED"),
    hasMonetizationStopped: state.eol.hasMonetizationStopped,
    eolConfig: state.eol.eolConfig
  };
})(AccountDropdown);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AccountDropdown/AccountDropdown.jsx
// module id = 2842
// module chunks = 0